module.exports = __webpack_public_path__ + "static/media/stamp_11.74a0f4f3.png";